import PropTypes from 'prop-types';

import CmsBlock from 'Component/CmsBlock';
import ContentWrapper from 'Component/ContentWrapper';
import Loader from 'Component/Loader';
import PageCard from 'Component/PageCard/PageCard.container';
import {
    NoMatch as SourceNoMatch
} from 'SourceRoute/NoMatch/NoMatch.component';
import { PageCardPropsType } from 'Type/CMS.type';
import { scrollToTop } from 'Util/Browser';

import './NoMatch.override.style';

/** @namespace PeggysagePwa/Route/NoMatch/Component */
export class NoMatchComponent extends SourceNoMatch {
    static propTypes = {
        ...SourceNoMatch.propTypes,
        isLoading: PropTypes.bool.isRequired,
        items: PropTypes.arrayOf(PageCardPropsType).isRequired
    };

    /**
     * Override: remove call to update breadcrumb
     */
    // eslint-disable-next-line @scandipwa/scandipwa-guidelines/only-render-in-component
    componentDidMount() {
        this.cleanUpTransition();
        scrollToTop();
    }

    renderTitle() {
        return (
            <h1 block="NoMatch" elem="Title">
                <span>404</span>
            </h1>
        );
    }

    renderContentBlockCms() {
        return <CmsBlock identifier="page_not_found" />;
    }

    renderOrSeparator() {
        const { isLoading, items } = this.props;

        if (!items.length && !isLoading) {
            return null;
        }

        return (
            <p block="NoMatch" elem="OrSeparator">
                { __('Or') }
            </p>
        );
    }

    renderContent() {
        return (
            <div block="NoMatch" elem="Content">
                <p block="NoMatch" elem="Subtitle">
                    { __('Oupsss !') }
                </p>
                <p block="NoMatch" elem="Description">
                    { __('L’url a été modifiée ou n’existe pas') }
                </p>
                { this.renderContentBlockCms() }
                { this.renderOrSeparator() }
            </div>
        );
    }

    renderPageItem(child) {
        return (
            <PageCard
              page={ child }
            />
        );
    }

    renderRelatedPages() {
        const { isLoading, items } = this.props;

        if (!items.length && !isLoading) {
            return null;
        }

        // @TODO placeholders instead of Loader

        return (
            <div block="NoMatch" elem="RelatedPages">
                <Loader isLoading={ isLoading } />
                <h2 block="NoMatch" elem="RelatedPagesTitle">
                    { __('Prenez le temps d’apprendre une nouvelle technique') }
                </h2>
                <ul block="NoMatch" elem="Items">
                    { items.map((item, index) => (
                        // eslint-disable-next-line react/no-array-index-key
                        <li block="NoMatch" elem="Item" key={ index }>
                            { this.renderPageItem(item) }
                        </li>
                    )) }
                </ul>
            </div>
        );
    }

    /**
     * Override
     * @returns {JSX.Element}
     */
    render() {
        return (
            <main block="NoMatch" aria-label={ __('Page not found') }>
                <ContentWrapper
                  mix={ { block: 'NoMatch' } }
                  wrapperMix={ { block: 'NoMatch', elem: 'Wrapper' } }
                  label={ __('Page Not Found Content') }
                >
                    <div block="NoMatch" elem="Header">
                        { this.renderTitle() }
                        { this.renderContent() }
                    </div>
                    { this.renderRelatedPages() }
                </ContentWrapper>
            </main>
        );
    }
}

export default NoMatchComponent;
